module.exports = __webpack_public_path__ + "img/icon-pound.56082d8b.svg";